import { Box, Button, Grid, Tab, Tabs } from "@mui/material";
import { Buffer } from "buffer";
import saveAs from "file-saver";
import React, { useState } from "react";
import { LoggedInSkeleton } from "src/Components/Common/LoggedInSkeleton";
import useFetch from "src/Components/Common/useFetch";
import { a11yProps, TabPanel } from "src/Components/Recon360/ReconSettings/ReconSettings";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";
import ReconDownloadReports from "./ReconDownloadReports";

const ReconAnalytics = () => {
  const [value, setValue] = useState<number>(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <LoggedInSkeleton topBarButtons={[]}>
      <div>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Download Reports" {...a11yProps(0)} sx={{ textTransform: "none" }} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0} key={0}>
            <ReconDownloadReports />
          </TabPanel>
        </Box>
      </div>
    </LoggedInSkeleton>
  );
};

export const RuTemplateFeedback = () => {
  const [loading, setLoading] = useState(false);

  const DownloadTemplateTracking = () => {
    setLoading(true);
    useFetch<{ workBookBase64: string }>(API_ENDPOINTS.GET_RU_TEMPLATE_TRACKING.url, "GET", {
      failureMessage: API_ENDPOINTS.GET_RU_TEMPLATE_TRACKING.failureMessage,
      thenCallBack: (res) => {
        const excelData = Buffer.from(res.data.workBookBase64, "base64");
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([excelData], { type: res.headers["content-type"] || fileType });
        saveAs(blob, "TemplateTrackingOutput.xlsx");
        setLoading(false);
      },
      catchCallBack: () => {
        setLoading(false);
      },
    });
  };

  return (
    <Grid className="center_align fade_in">
      <Button
        variant="contained"
        className="theme_btn"
        sx={{
          m: "30px",
        }}
        onClick={() => DownloadTemplateTracking()}
        disabled={loading}
      >
        {loading ? (
          <span className="file-icon">
            <i className="fas fa-circle-notch fa-spin" />
          </span>
        ) : null}
        Download
      </Button>
    </Grid>
  );
};

export default ReconAnalytics;
